interface IPubsub {
  publish: (topic: string, ...args: any) => boolean;
  // eslint-disable-next-line @typescript-eslint/ban-types
  subscribe: (topic: string, func: Function) => string;
  unsubscribe: (token: string) => void;
}
const Pubsub = {} as IPubsub;
(function (q) {
  var topics = {} as { [key: string]: any }, // 回调函数存放的数组
    subUid = -1;
  // 发布方法
  q.publish = function (topic, args) {
    if (!topics[topic]) {
      return false;
    }

    setTimeout(function () {
      var subscribers = topics[topic],
        len = subscribers ? subscribers.length : 0;

      while (len--) {
        subscribers[len].func(topic, args);
      }
    }, 0);

    return true;
  };
  //订阅方法
  q.subscribe = function (topic, func) {
    if (!topics[topic]) {
      topics[topic] = [];
    }

    const token = (++subUid).toString();
    topics[topic].push({
      token: token,
      func: func,
    });
    return token;
  };
  //退订方法
  q.unsubscribe = function (token) {
    for (var m in topics) {
      if (topics[m]) {
        for (let i = 0, j = topics[m].length; i < j; i++) {
          if (topics[m][i].token === token) {
            topics[m].splice(i, 1);
            return token;
          }
        }
      }
    }
    return;
  };
})(Pubsub);
export default Pubsub;
